module.exports = __webpack_public_path__ + "static/006-a12aa09d19bb213c6bf81999e32749c1.png";